import { capitalizeFirstLetter, isArrayLength } from './genericHelpers';

export const getTalentAttribute = (listing, attribute) => {
  if (!listing?.id) return null;
  const attributesMap = {
    level: capitalizeFirstLetter(listing.attributes.publicData.pub_talent_level),
    title: listing.attributes.title,
    description: listing.attributes.description,
    profileDetails: listing.attributes.publicData.profileDetails,
    createdAt: listing.attributes.createdAt,
    interest: listing.attributes.publicData.pub_interest,
  };
  return attributesMap[attribute];
};
export const getSchoolAttribute = (listing, attribute) => {
  if (!listing?.id) return null;
  const attributesMap = {
    id: listing.id.uuid,
    title: listing.attributes.title,
    schoolDisplayName: listing.attributes.publicData.schoolDisplayName,
    logo: listing.images[0]?.attributes?.variants['scaled-medium']?.url,
  };
  return attributesMap[attribute];
};

export const filterListingsByUserType = (listings, userType) => {
  if (!isArrayLength(listings)) {
    return [];
  }

  return (
    listings.filter(listing => listing?.attributes?.publicData?.listingCategory === userType) || []
  );
};
export const getProfileVideoURL = data => {
  if (!data?.length) return null;

  return data.map(item => ({
    fileLink: item.fileLink,
    key: item.key,
    size: item.size,
    name: item.name,
  }));
};

export const getProfileVideos = listing => {
  if (!listing?.id) return [];
  return listing?.attributes?.publicData?.profileVideos || [];
};
export const getListingSocialMedia = listing => {
  if (!listing?.id) return [];
  return listing?.attributes?.publicData?.social_media || [];
};

export const getTalentPlus = listing => {
  if (!listing?.id) return [];
  return listing?.attributes?.publicData?.talentPlus;
};
export const getUnlockableContent = listing => {
  if (!listing?.id) return {};
  return listing?.attributes?.publicData?.unlockableContent;
};

export const getCompanyNamesAndIds = listings => {
  if (!Array.isArray(listings) || listings.length === 0) {
    return [];
  }

  return listings
    .map(listing => {
      const publicData = listing?.attributes?.publicData;
      const name = publicData?.pub_company ?? publicData?.agencyName;
      const id = listing?.id?.uuid;

      return { name, id };
    })
    .filter(item => Boolean(item.name) && Boolean(item.id));
};

export const getListingAssociatedUsers = listing => {
  if (!listing?.id) return [];
  return listing?.attributes?.publicData?.associatedUsers || [];
};
export const getTransactionProcessAlias = listing => {
  if (!listing?.id) return [];
  return listing?.attributes?.publicData?.transactionProcessAlias || null;
};

export const getListingCategory = listing => {
  if (!listing?.id) return null;
  return listing?.attributes?.publicData?.listingCategory || null;
};
export const getAgencyName = listing => {
  if (!listing?.id) return null;
  return listing?.attributes?.publicData?.agencyName || null;
};
export const getListingSports = listing => {
  if (!listing?.id) return [];
  return listing?.attributes?.publicData?.pub_sports || [];
};
export const getRewardAvailability = listing => {
  if (!listing?.id) return null;
  return listing?.attributes?.publicData?.availability || null;
};

export const getListingAvailability = listing => {
  if (!listing?.id) return null;
  return listing?.attributes?.publicData?.availability || null;
};
